import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {
  Accordion,
  AccordionGroup,
  AccordionHeader,
  AccordionContent,
  AccordionHeaderSecondary
} from 'core/controls';
import { Translate, TranslateContext } from 'core/translate';
import SimpleOptionGroup from '../common/options/SimpleOptionGroup';
import SimpleOption from '../common/options/SimpleOption';
import OptionsPage from '../common/OptionsPage';

const ColorOptionSubgroup = ({
  options,
  header,
  analyticsKey,
  onChange,
  onDetails
}) => {
  if (options.length === 0) {
    return null;
  }

  const optionList = options.map(option => (
    <SimpleOption
      key={option.id}
      option={option}
      analyticsKey={analyticsKey}
      analyticsKey2={option.description}
      onChange={onChange}
      onDetails={onDetails}
    />
  ));

  return (
    <Fragment>
      {header && (
        <AccordionHeaderSecondary>
          <Translate value={`color.${header}`} />
        </AccordionHeaderSecondary>
      )}
      <div>{optionList}</div>
    </Fragment>
  );
};

const ColorOptionGroup = ({
  header,
  groups,
  analyticsKey,
  id,
  onChange,
  onDetails
}) => {
  const count = _.flatMap(groups, 'items').length;

  if (count === 0) {
    return null;
  }

  const subgroups = groups.map((group, index) => (
    <ColorOptionSubgroup
      key={group.header}
      header={index === 0 ? '' : group.header}
      options={group.items}
      analyticsKey={analyticsKey}
      onChange={onChange}
      onDetails={onDetails}
    />
  ));

  return (
    <AccordionGroup id={id}>
      <Fragment>
        <AccordionHeader analyticsKey={header}>
          {header} ({count})
        </AccordionHeader>
        <AccordionContent>{subgroups}</AccordionContent>
      </Fragment>
    </AccordionGroup>
  );
};

const Colors = ({ interior, exterior, stripes, tops }) => {
  return (
    <OptionsPage>
      {({ onChange, onDetails }) => (
        <Accordion>
          <TranslateContext.Consumer>
            {translate => (
              <Fragment>
                <ColorOptionGroup
                  header={translate('component.common.select.exterior.color')}
                  groups={exterior}
                  analyticsKey="exterior color"
                  id="exterior-colors"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.exterior.top')}
                  options={tops}
                  analyticsKey="exterior color"
                  id="top-colors"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.exterior.stripes')}
                  options={stripes}
                  analyticsKey="exterior color"
                  id="stripe-colors"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <ColorOptionGroup
                  header={translate('component.common.select.interior.color')}
                  groups={interior}
                  analyticsKey="interior color"
                  id="interior-colors"
                  onChange={onChange}
                  onDetails={onDetails}
                />
              </Fragment>
            )}
          </TranslateContext.Consumer>
        </Accordion>
      )}
    </OptionsPage>
  );
};

const mapStateToProps = state => {
  const { exterior, interior, stripe, top } = state.config.colors;
  return {
    exterior,
    interior,
    stripes: stripe,
    tops: top
  };
};

export default withRouter(connect(mapStateToProps)(Colors));
